import {
  APP_INITIALIZER,
  CUSTOM_ELEMENTS_SCHEMA,
  NO_ERRORS_SCHEMA,
  NgModule,
} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SharedModule } from './shared/shared.module';
import { CoreModule } from './core/core.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MaterialModule } from './material/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HomeComponent } from './home-page/home-page.component';
import { CreateAzureAccountDialogComponent } from './home-page/create-azure-account-dialog/create-azure-account-dialog.component';
import { FormAwsComponent } from './form/form-aws/form-aws.component';
import { FormAzureComponent } from './form/form-azure/form-azure.component';
import {
  MSAL_INSTANCE,
  MSAL_INTERCEPTOR_CONFIG,
  MsalBroadcastService,
  MsalGuard,
  MsalInterceptor,
  MsalService,
} from '@azure/msal-angular';
import { CoreService } from './services/core.service';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    CreateAzureAccountDialogComponent,
    FormAwsComponent,
    FormAzureComponent,
  ],
  imports: [
    MaterialModule,
    BrowserModule,
    AppRoutingModule,
    SharedModule,
    CoreModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  providers: [
    {
      provide: MSAL_INSTANCE,
      useFactory: () => CoreService.createMsalInstance()
    },
    MsalService,
    MsalGuard,
    MsalBroadcastService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true
    },
    {
      provide: MSAL_INTERCEPTOR_CONFIG,
      useFactory: (coreService: CoreService) => coreService.fetchMsalInterceptorConfig(),
      deps: [CoreService]
    },
    {
      provide: APP_INITIALIZER,
      useFactory: (msalService: MsalService, coreService: CoreService) => async () => {
        // Step 1: Handle any auth redirects from Azure AD
        // This must complete before we can proceed with initialization
        await new Promise<void>((resolve) => {
          msalService.handleRedirectObservable().subscribe({
            next: () => {
              console.log('MSAL redirect handled');
              resolve();
            },
            error: (err) => {
              console.error(err);
              resolve();
            }
          });
        });
        
        // Step 2: Set up MSAL configuration (synchronous)
        // This doesn't actually initialize auth - it just sets up the config
        msalService.initialize();
        console.log('MSAL configuration applied');
    
        // Step 3: Initialize our app's auth state and handle login if needed
        await coreService.init();
        console.log('CoreService initialized');
      },
      deps: [MsalService, CoreService],
      multi: true
    }
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class AppModule {}
